export default "__VITE_ASSET__9HgHbyAg__"